import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  Dropdown,
  message,
  Select,
  Image,
  Modal,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import ParentStore from "../store/ParentStore";
import NotificationStore from "../store/NotificationStore";
import ParentsAdd from "./ParentsAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { CloseOutlined } from "@ant-design/icons";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
class ParentList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.onDelete = this.onDelete.bind(this);

    this.parentStore = new ParentStore();
    this.notificationStore = new NotificationStore();
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadList: 0,
      openParentAddForm: false,
      parentId: "",
      listDataUpdate: false,
      companyFieldHighlight: false,
      searchField: "",
      classId: "",
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Students Name",
        title: context.translate("_STUDENTS_NAME_"),
        width: 150,
        dataIndex: "studentName",
        key: "studentName",
        ellipsis: {
          showTitle: true,
        },
        fixed: "left",

        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("parentlist") && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Class",
        title: context.translate("_CLASS_"),
        width: 150,
        dataIndex: "className",
        key: "className",
        ellipsis: {
          showTitle: true,
        },
        fixed: "left",
      },
      {
        // title: "Parents Name",
        title: context.translate("_PARENTS_NAME_"),
        width: 150,
        dataIndex: "username",
        key: "username",
        ellipsis: {
          showTitle: true,
        },
        fixed: "left",
      },
      {
        // title: "Mobile No",
        title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_MOBILE_"),
        width: 150,
        dataIndex: "mobileno",
        key: "mobileno",
        ellipsis: {
          showTitle: true,
        },
        fixed: "left",
      },
      {
        // title: "Password",
        title: context.translate("_FLEET_LOGIN_PASSWORDLBL_"),
        width: 150,
        dataIndex: "password",
        key: "password",
        ellipsis: {
          showTitle: true,
        },
        fixed: "left",
      },
      {
        // title: "Email Id",
        title: context.translate("_FLEET_USER_USERLIST_EMAIL_"),
        width: 150,
        dataIndex: "emailId",
        key: "emailId",
        ellipsis: {
          showTitle: true,
        },
        fixed: "left",
      },

      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        fixed: "right",
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        width: 50,
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("parentlist") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("parentlist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      await this.handleSearch();
    }
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    await this.notificationStore.getAllClass();
    this.setState({ pageSize: 50 });

    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {this.context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {this.context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        if (!this.state.companyId) {
          this.setState({ companyFieldHighlight: true });
        } else {
          this.setState({ companyFieldHighlight: false });
        }
        if (this.state.companyId) {
          this.setState({ companyFieldHighlight: false, loading: true });
          const result = [];
          this.columns.map((obj) => result.push(obj.dataIndex));
          //  console.log(result.toString())
          var getData = {
            cid: this.state.companyId,
            searchField: this.state.searchField,
            colList: result,
            classId: this.state.classId,
          };
          console.log(getData);
          if (val.key === "excel") {
            this.parentStore.exportExcel(getData);
          }
          if (val.key === "pdf") {
            this.parentStore.exportPdf(getData);
          }
        }
      },
    };
  }

  onEdit = async (record) => {
    console.log(record);
    console.log(record.parentId);
    const parentId = record.parentId;
    if (parentId) {
      // this.props.navigate("/parentadd/" + parentId);
      await this.setState({ parentId: parentId });
      await this.setState({ openParentAddForm: true });
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      searchField: "",
      classId: "",
    });
    console.log(comp);
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.parentStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }

  searchInput = async (e) => {
    const value = e.target.value;

    // await this.setState({searchField:value})
    if (value.length > 3) {
      await this.parentStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });

      await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      await this.parentStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        // searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ currentPage: 1 });
    }
  };

  async onDelete(record) {
    console.log(record);
    const response = await this.parentStore.deleteRecord({
      parentId: record.parentId,
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
  fillClassName = () => {
    var classNames = [];
    classNames.push("KG1", "KG2");
    for (let i = 1; i <= 12; i++) {
      classNames.push("Grade" + i);
    }
    if (classNames) {
      return classNames.map((value, index) => {
        return <Select.Option value={index + 1}>{value}</Select.Option>;
      });
    }
  };
  responseMsg = async (response) => {
    if (response?.success === "S") {
      await message.success(response.message);

      await this.setState({ openParentAddForm: false });
      this.handleSearch();
      await this.setState({ listDataUpdate: true });
    } else {
      message.error(response.message);
    }
  };

  closeModal = () => {
    this.setState({ openParentAddForm: false });
  };

  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true, searchField: "", classId: "" });
      await this.parentStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
        searchField: "",
      });
      this.setState({
        loading: false,
        currentPage: 1,
        searchField: "",
        classId: "",
      });
    }
  };

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  style={companyInputBox}
                />
                <Input
                  className="searchInput"
                  placeholder={this.context.translate(
                    "_SEARCH_BY_STUDENT_PARENT_MOBILE_EMAIL_"
                  )}
                  style={{ width: 500, borderRadius: "25px" }}
                  onChange={async (e) => {
                    await this.setState({ searchField: e.target.value });
                    await this.searchInput(e);
                  }}
                  value={this.state.searchField ? this.state.searchField : ""}
                />

                <Select
                  style={{ width: 125 }}
                  className="searchInput"
                  name="classId"
                  placeholder={this.context.translate("_SELECT_CLASS_")}
                  // placeholder="Select Class"
                  value={this.state.classId ? this.state.classId : null}
                  onSelect={async (clsId) => {
                    await this.parentStore.loadData({
                      offset: 0,
                      classId: clsId,
                      limit: this.state.pageSize,
                      // searchField: value,
                      companyId: this.state.companyId,
                    });
                    await this.setState({ loadList: 1, classId: clsId });
                  }}
                  fieldNames={{ value: "classId", label: "className" }}
                  optionFilterProp="children"
                  options={this.notificationStore?.getClass}
                />
              </Space>
            </Col>
            <Col>
              <Space
                style={{
                  float:
                    this.context.locale.direction === "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.parentStore?.parents?.length > 0 ? false : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Tooltip
                      title={this.context.translate("_DOWNLOAD_")}
                      placement="top"
                    >
                      <Image
                        style={{
                          height: 18,
                          alignItems: "center",
                          marginInlineEnd: "30px",
                        }}
                        src={downloadIcon}
                      ></Image>
                    </Tooltip>
                  </Dropdown>
                </Button>
                {/* <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openParentAddForm: true, parent: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button> */}
              </Space>
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            total={this.parentStore?.total}
            columns={this.columns}
            dataSource={this.parentStore?.parents}
            loading={this.parentStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openParentAddForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   title={this.context.translate("")}
          //   centered
          //   visible={this.state.openParentAddForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openParentAddForm: false });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openParentAddForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_PARENT_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_PARENT_DETAILS_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openParentAddForm: false })}
            onCancel={() =>
              this.setState({ openParentAddForm: false, fuelId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <ParentsAdd
                parentId={this.state.parentId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
ParentList.contextType = StoreContext;
export default observer(withRouter(ParentList));
